/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions, IFilterService, ILogService} from 'angular';
import {rolePrefix, TSRole} from '../../../models/enums/TSRole';
import TSEigenleistung from '../../../models/TSEigenleistung';
import TSSchadenfall from '../../../models/TSSchadenfall';
import RoleUtilService from '../../service/RoleUtilService';
import SchadenfallModelManager from '../../service/SchadenfallModelManager';
import IScope = angular.IScope;
import ITimeoutService = angular.ITimeoutService;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./dv-eigenleistungen-list.html');
require('./dv-eigenleistungen-list.scss');

export class DVEigenleistungenListComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        eigenleistungen: '=',
        schadenfall: '<',
        onEdit: '&',
        onDelete: '&',
        readonly: '<',
        schaetzung: '<',
    };
    template = template;
    controller = DVEigenleistungenListController;
    controllerAs = 'vm';
}

export class DVEigenleistungenListController {

    itemsByPage: number;
    colnumber: number | undefined = undefined;
    eigenleistungen: Array<TSEigenleistung> = []; //Liste die im Gui angezeigt wird
    pagination: any;
    onEdit: (paramObj: any) => void;
    onDelete: (paramObj: any) => void;
    readonly: boolean;
    schadenfall: TSSchadenfall;
    schaetzung: boolean;

    static $inject: any[] = [
        '$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate',
        '$timeout', 'SchadenfallModelManager',
    ];

    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private roleUtilService: RoleUtilService,
                private $window: IWindowService, private $translate: ITranslateService,
                private $timeout: ITimeoutService, private schadenfallModelManager: SchadenfallModelManager,
    ) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {

        this.$timeout(() => {
            //can only initialize real value after view is stable (ng-ifs are done)
            this.initColNumber();
        });
        this.calculateBerechtigterBetragForOldCases();
    }

    private calculateBerechtigterBetragForOldCases() {
        // the following calculation is for handling old cases, where Berechtigter Betrag belongs to each Eigenleistung, not to the Schadenfall
        if (this.schadenfall.berechtigterBetragEigenleistungen === null || this.schadenfall.berechtigterBetragEigenleistungen === 0) {

            this.schadenfall.berechtigterBetragEigenleistungen = this.eigenleistungen.reduce(
                (accumulator: number, currentValue: TSEigenleistung) => accumulator + currentValue.berechtigterBetrag, 0);
        }
    }

    public calcTotalEL(): number {
        let total = 0;
        if (this.eigenleistungen !== undefined) {
            for (let obj of this.eigenleistungen) {
                if (obj.eigenleistungStundenDaten !== undefined) {
                    total += obj.getBetragTotal();
                }
            }
        }
        return total;
    }

    public calcTotalELHours(): number {
        let total = 0;
        if (this.eigenleistungen !== undefined) {
            for (let obj of this.eigenleistungen) {
                if (obj.eigenleistungStundenDaten !== undefined) {
                    total += obj.getArbeitsstundenTotal();
                }
            }
        }
        return total;
    }

    public getFilterroles(): Array<TSRole> {
        return this.roleUtilService.getAllRolesButGesuchstellerArray();

    }

    editClicked(eigenleistungToEdit: any, event: any) {
        this.onEdit({eigenleistung: eigenleistungToEdit, event: event});
    }

    deleteClicked(eigenleistungToDelete: any, event: any) {
        this.onDelete({eigenleistung: eigenleistungToDelete, event: event});
    }

    public translateAktiv(inaktiv: boolean): string {
        return inaktiv ? (this.$translate.instant('INAKTIV')) : (this.$translate.instant('AKTIV'));

    }

    public translateRoles(roles: Array<TSRole>): string {
        let prefix = rolePrefix();
        return roles.map((element) => {
            return this.$translate.instant(prefix + TSRole[element])
        }).join(', ');

    }

    public translateRole(role: TSRole): string {
        let prefix = rolePrefix();
        return this.$translate.instant(prefix + TSRole[role])

    }

    public getColumnsNumber(): number {
        if (this.colnumber === undefined) {
            this.initColNumber();
        }
        return this.colnumber!;
    }

    private initColNumber() {
        let element = angular.element('.dv-eigenleistungen-list .header-row').first();
        if (element) {
            this.colnumber = element.get(0).childElementCount;
        } else {
            //could not determine actual number, just returing an approximation
            this.colnumber = 7;
        }
    }

    private speichernGesuch(): void {
        if (this.schadenfall) {
            this.schadenfallModelManager.saveSchadenfall(this.schadenfall);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-eigenleistungen-list/dv-eigenleistungen-list.ts